import { notify } from '../../../../utils/services/notification';
import { getAccessToken, getAddress } from '../../../../utils/services/auth';
import axios from 'axios';
import React from 'react'

function Statistics() {
    React.useEffect(() => {
        const fetchData = async () => {
            try {
                const address = getAddress(); // Assuming getAddress is defined elsewhere
                const accessToken = getAccessToken(); // Assuming getAccessToken is defined elsewhere

                const response = await axios.post(
                    'https://encryption-dev.lighthouse.storage/api/stats/1',
                    { address },
                    {
                        headers: {
                            Authorization: `Bearer ${accessToken}`
                        }
                    }
                );

                // console.log('Response:', response.data);
            } catch (error) {
                notify(`Error: ${error}`,'error');
                console.error('Error fetching statistics:', error);
            }
        };

        fetchData();
    }, []);
    return (
        <div></div>
    )
}

export default Statistics